import * as React from "react";

export const MonitorHeartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="M100-590v-117.69Q100-738 121-759t51.31-21h615.38Q818-780 839-759t21 51.31V-590h-60v-117.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-590zm72.31 410Q142-180 121-201t-21-51.31V-370h60v117.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h615.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-370h60v117.69Q860-222 839-201t-51.31 21zM400-290q8.31 0 15.81-4.15 7.5-4.16 11.34-12.47L560-572.31l52.85 105.69q3.84 8.31 11.34 12.47Q631.69-450 640-450h220v-60H658.85l-71.7-143.38q-3.84-7.93-11.15-11.27-7.31-3.35-16-3.35-8.31 0-15.81 3.35-7.5 3.34-11.34 11.27L400-387.69l-52.85-105.69q-3.84-8.31-11.34-12.47Q328.31-510 320-510H100v60h201.15l71.7 143.38q3.84 8.31 11.34 12.47Q391.69-290 400-290m80-190" />
  </svg>
);

export const AirIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="M460-160q-50 0-85-35t-35-85h80q0 17 11.5 28.5T460-240t28.5-11.5T500-280t-11.5-28.5T460-320H80v-80h380q50 0 85 35t35 85-35 85-85 35M80-560v-80h540q26 0 43-17t17-43-17-43-43-17-43 17-17 43h-80q0-59 40.5-99.5T620-840t99.5 40.5T760-700t-40.5 99.5T620-560zm660 320v-80q26 0 43-17t17-43-17-43-43-17H80v-80h660q59 0 99.5 40.5T880-380t-40.5 99.5T740-240" />
  </svg>
);

export const ECGHeartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="M480-120q-18 0-34.5-6.5T416-146L148-415q-35-35-51.5-80T80-589q0-103 67-177t167-74q48 0 90.5 19t75.5 53q32-34 74.5-53t90.5-19q100 0 167.5 74T880-590q0 49-17 94t-51 80L543-146q-13 13-29 19.5t-34 6.5m40-520q10 0 19 5t14 13l68 102h166q7-17 10.5-34.5T801-590q-2-69-46-118.5T645-758q-31 0-59.5 12T536-711l-27 29q-5 6-13 9.5t-16 3.5-16-3.5-14-9.5l-27-29q-21-23-49-36t-60-13q-66 0-110 50.5T160-590q0 18 3 35.5t10 34.5h187q10 0 19 5t14 13l35 52 54-162q4-12 14.5-20t23.5-8m12 130-54 162q-4 12-15 20t-24 8q-10 0-19-5t-14-13l-68-102H236l237 237q2 2 3.5 2.5t3.5.5 3.5-.5 3.5-2.5l236-237H600q-10 0-19-5t-15-13z" />
  </svg>
);
